import * as Yup from 'yup';

import { Lead } from 'models/Leads';
import { ScheduledMessage } from 'models/automation/ScheduledMessages';
import { TIMEZONES } from 'utils/constants/timezones';
import {
  BROWSER_TIMEZONE,
  findClosestTimezone,
  getTimezoneId,
} from 'utils/timezones';

export const scheduledMessagesRescheduleModalSchema = () =>
  Yup.object({
    date: Yup.date().required(),
    time: Yup.date().required(),
    timezone: Yup.string().required(),
  });

export type ScheduledMessagesRescheduleModalFormValues = Yup.InferType<
  ReturnType<typeof scheduledMessagesRescheduleModalSchema>
>;

export const getFormDefaultValues = ({
  lead,
  scheduledMessage,
}: {
  lead?: Lead;
  scheduledMessage: ScheduledMessage;
}): ScheduledMessagesRescheduleModalFormValues => {
  const defaultTimezone =
    getTimezoneId({ dateString: lead?.checkInDateTimeString }) ??
    BROWSER_TIMEZONE;
  const timezone =
    defaultTimezone in TIMEZONES
      ? defaultTimezone
      : findClosestTimezone({ timezone: defaultTimezone });

  return {
    date: scheduledMessage.expectedFireTime ?? new Date(),
    time: scheduledMessage.expectedFireTime ?? new Date(),
    timezone,
  };
};
